import React from "react";
import _ from "lodash";
import { gql, graphql } from "react-apollo";

const USER = gql`
  query QueryUser($id: ID) {
    User(id: $id) {
      id
      facebookUserId
    }
  }
`;

const withUser = WrappedComponent => {
  return graphql(USER, {
    name: "userQuery",
    options: ownProps => {
      return {
        variables: {
          id: _.get(ownProps, "loggedUserQuery.loggedInUser.id")
        }
      };
    }
  })(
    class User extends React.Component {
      render() {
        if (this.props.userQuery.loading) {
          return <div>loading...</div>;
        }
        return <WrappedComponent {...this.props} />;
      }
    }
  );
};

export default withUser;



// WEBPACK FOOTER //
// ./src/templates/authenticate/withUser.js